export const PRODUCTS = {
  AI_TUTOR_HUB: {
    id: 'prod_S7saWDcKrGhM1h',
    name: 'AI TutorHub, AI Tutoring Hub, AI Side Hustle Course',
    description: 'Unlimited access to the AI Chaperones Tutor Hub and Learning Hub — an immersive ecosystem of interactive, chatbot-led AI tutoring and educational tools. AI Side Hustle Course, Free Community',
    priceId: 'price_1RDcpVB221ZrhS3nctUdu5jv',
    yearlyPriceId: 'price_1RDcpVB221ZrhS3nXYZ789',
    mode: 'subscription',
    price: 49.00,
    interval: 'month'
  },
  AI_LEARNING_HUB: {
    id: 'prod_S7rf5dPOMFsJ1l',
    name: 'AI Tutor Hub & AI Learning Hub',
    description: 'Unlimited access to the AI Chaperones Tutor Hub and Learning Hub — an immersive ecosystem of interactive, chatbot-led AI tutoring and educational tools. Includes a 5-day free trial – cancel anytime before billing begins.',
    priceId: 'price_1RDbwTB221ZrhS3n4Q7iMlV3',
    yearlyPriceId: 'price_1RDbwTB221ZrhS3nABC123',
    mode: 'subscription',
    price: 49.00,
    interval: 'month'
  }
} as const;